<div class="feature-card">
  <mat-card class="card premium-tab" *ngIf="premiumFeatures$ | async as premiumFeatures">
    <mat-card-content>
      <form class="form">
        <div class="form-group municipality-permission">
          <div class="header-container">
            <label class="label">{{ 'module.userProfile.generalInformation.functionalityOnOffText' | translate
              }}</label>
            <label class="label2">{{ 'module.userProfile.generalConfiguration.activePremiumTabLabel' | translate
              }}</label>
            <label class="label4">{{ 'module.userProfile.generalConfiguration.teaserPremiumTabLabel' | translate
              }}</label>
            <label class="label3">{{ 'module.userProfile.generalConfiguration.linkPremiumTabLabel' | translate
              }}</label>
          </div>
          <div class="page-permissions">
            <div *ngFor="let premiumFeature of premiumFeatures">
              <div class="checkbox-row">
                <label class="checkbox-label" [ngClass]="!premiumFeature.isActive ? 'not-active-feature' : ''">{{
                  premiumFeature.name }}</label>
                <mat-checkbox class="checkbox" [disabled]="!(isMunicipalityActive$ | async) || !premiumFeature.isActive"
                  [name]="premiumFeature.code" value="restriction" [checked]="!premiumFeature.isRestricted"
                  (change)="toggleFeature($event.checked, premiumFeature.guid)"></mat-checkbox>
                <mat-checkbox class="second-checkbox"
                  [disabled]="premiumFeature.isTeaserDisabled || !(isMunicipalityActive$ | async) || !premiumFeature.isActive"
                  [name]="premiumFeature.code" [checked]="premiumFeature.isTeaser" value="teaser"
                  (change)="toggleTeaser($event.checked, premiumFeature.guid)"></mat-checkbox>
                <div class="permission-link"
                  *ngIf="premiumFeature.allowLinkUpdate && (isMunicipalityActive$ | async) && premiumFeature.isActive">
                  <input title="premium-feature-link" type="text" class="input-link"
                    [disabled]="!(isMunicipalityActive$ | async) || !premiumFeature.isActive"
                    [value]="premiumFeature.link" (change)="updateLink($event, premiumFeature)"
                    [readonly]="!premiumFeature.isActive" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>